import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** Alert notifier injected by plugins/notifier.js. */
export function useNotifier(): Vue['$notifier'] {
  return resolveInjected('$notifier');
}
